import { render, staticRenderFns } from "./EvaluationReports.vue?vue&type=template&id=8fdbfe8e&scoped=true"
import script from "./EvaluationReports.vue?vue&type=script&lang=js"
export * from "./EvaluationReports.vue?vue&type=script&lang=js"
import style0 from "./EvaluationReports.vue?vue&type=style&index=0&id=8fdbfe8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdbfe8e",
  null
  
)

export default component.exports